module.exports = require("./tg.js");